import React from 'react';
import { Link, withRouter } from 'react-router';
import PropTypes from 'prop-types';


class NavLink extends React.Component {


    render() {
        if( !this.props.link ){ return console.error("'link' prop needs to be specified on NavLink") };
        
        const { className, ...remainderProps } = this.props;
        let isActive = className.indexOf( 'navigation-link' ) > -1 && this.context.router.isActive(this.props.link, false);

        // exception needed here because the url structure of the child pages for partnerships doesnt conform to how the rest of the website does
        if( this.props.link.indexOf( 'partnerships' ) > -1 && window.location.pathname.indexOf( 'partnerships' ) > -1 ){ isActive = true };

        const classNameAttr = isActive ? `${ className } active` : className ;

        let excludes = [ 'router', 'params', 'location', 'routes', 'class' ];
        Object.keys( remainderProps ).forEach( item => {
            if( excludes.indexOf( item ) > -1 ){ delete remainderProps[ item ] };
        });
        
        return(
            <Link className={ classNameAttr } { ...remainderProps }>
                {this.props.children}
            </Link>
        );
    }
}

NavLink.contextTypes = {
    router: PropTypes.object
};

export default withRouter( NavLink );



// WEBPACK FOOTER //
// src/client/components/dashboardNew/objects/NavLink.js